import {Component, inject} from '@angular/core';
import {ApiStorageUnitService, StorageUnitDto} from '|api/document';
import {getSuperclassEntityType, StorageUnitView} from '|shared';
import {StorageUnitInsertableObject} from '../storage-unit-insert-dialog/storage-unit-insert-dialog.component';
import {LabelComponent, LoadingIndicatorService} from '@icz/angular-essentials';
import {injectModalData, injectModalRef} from '@icz/angular-modal';
import {IczEagerDatasource} from '@icz/angular-table';
import {StorageUnitsComponent} from '../storage-units/storage-units.component';

export interface StorageUnitSelectorDialogData {
  storageUnitId?: number;
  objectsToInsert: StorageUnitInsertableObject[];
  isMove: boolean;
  fileCabinetId?: number; // todo 19555 connect this when find-valid-storage-units
}

@Component({
  selector: 'icz-storage-unit-selector-dialog',
  templateUrl: './storage-unit-selector-dialog.component.html',
  styleUrls: ['./storage-unit-selector-dialog.component.scss'],
  imports: [StorageUnitsComponent, LabelComponent]
})
export class StorageUnitSelectorDialogComponent {

  protected loadingService = inject(LoadingIndicatorService);
  private modalRef = injectModalRef<Nullable<StorageUnitDto>>();
  private apiStorageUnitService = inject(ApiStorageUnitService);
  private modalData = injectModalData<StorageUnitSelectorDialogData>();

  dataSource = new IczEagerDatasource(
    () => this.apiStorageUnitService.storageUnitFindValidStorageUnitsForEntities({
      body: {
        // moveFromStorageUnitId: this.modalData.isMove ? this.modalData.storageUnitId : undefined, // todo 19555 uncomment when be
        entities: this.modalData.objectsToInsert.map(obj => ({
          id: obj.id!,
          entityType: getSuperclassEntityType(obj.entityType!),
        })),
        findForMove: this.modalData.isMove,
      },
    })
  );

  readonly StorageUnitView = StorageUnitView;

  itemSelected(selection: Nullable<StorageUnitDto>) {
    if (selection) {
      this.modalRef.close(selection);
    }
  }

}
